import { is10S, isJZ } from '@/const';

export default () => {
  return !(isJZ || is10S);
};
